import React, { useEffect, useState } from 'react';
import { Box, Text, VStack, HStack, Button, View } from 'native-base';
import { defaultNavigationProps } from '../Navigator/Navigator';
import PortfolioBadge, { position } from './Components/Badge/PortfolioBadge';
import { useAppContext } from '../Universal/API/Context-API/AppContext';
import { PorfolioList } from '../Universal/API/Context-API/AppProvider';
import ExpandedPortfolio from './Components/Expanded/ExpandedPortfolio';
import { Helmet } from 'react-native-helmet-async';

const Portfolio: React.FC<defaultNavigationProps> = ({ navigation, route }) => {

    const { id } = route.params ?? {};
    const { portfolioList } = useAppContext()


    const [portfolio, setPortfolio] = useState<PorfolioList | null>(null)
    // const [openBig, setOpenBig] = useState<boolean>(false)
    const [position, setPosition] = useState<position | null>(null)

    useEffect(() => {
        if (id) {
            console.log('looking for id')
            const find = portfolioList.find(port => port.name == id)
            if (find && !portfolio) {
                console.log('find', find)
                setPortfolio(find)
                if (!position)
                    setPosition({
                        height: 300, width: 300,
                        x: 0, y: 0
                    })
            }
        } else {
            setPortfolio(null)
        }
    }, [id, portfolioList])

    useEffect(() => {
        console.log(
            'portfolio', portfolio,
            position
        )
        if (portfolio && position) {
            console.log(
                portfolio,
                position
            )
        }
        // setOpenBig(true)
        // else 
        // setOpenBig(false)
    }, [portfolio, position])
    return (
        <>
            {/* <Helmet prioritizeSeoTags>
                <title>Портфолио | Deante — Реализованные проекты с плиткой и керамогранитом</title>
                <meta property="og:title" content="Портфолио | Deante — Реализованные проекты с плиткой и керамогранитом" />
                <meta
                    name="description"
                    content="Вдохновляйтесь примерами реализованных интерьеров с использованием плитки и керамогранита Deante. Живые фотографии, стильные решения, современные коллекции."
                />
                <meta
                    property="og:description"
                    content="Примеры работ и реализованные проекты с использованием плитки Deante: ванные комнаты, кухни, салоны, общественные пространства и архитектурные решения."
                />
                <meta property="og:url" content="https://deante.pro/portfolio" />
                <meta name="twitter:title" content="Портфолио реализованных проектов Deante" />
                <meta name="twitter:description" content="Вдохновляющие примеры использования плитки Deante. Реальные проекты." />
                <meta name="twitter:image" content="https://deante.pro/js/logo/portfolio-preview.jpg" />
            </Helmet> */}

            <Box flex={1} safeArea p={4} bg="white">
                <VStack space={4} alignItems="center">
                    <Text fontSize="2xl" fontWeight="bold">
                        Наши проекты:
                    </Text>
                    <HStack space={3} flexWrap={'wrap'} justifyContent={'center'}>
                        {portfolioList.map(portfolio => {

                            return (<View paddingBottom={10}><PortfolioBadge
                                onPress={(params) => {

                                    setPosition(params.position)
                                    setPortfolio(params.portfolio)
                                    navigation.setParams({
                                        id: params.portfolio.name
                                    })
                                }}
                                portfolio={portfolio} /></View>)
                        })}

                        {/* <Button colorScheme="secondary">Project 2</Button> */}
                    </HStack>

                </VStack>

                {
                    portfolio && position && <ExpandedPortfolio portfolio={portfolio} position={position} visible={true} onClose={() => {
                        setPosition(null)
                        setPortfolio(null)
                        navigation.setParams({
                            id: undefined
                        })
                    }} />
                }
            </Box>
        </>
    );
};

export default React.memo(Portfolio);